import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EliminaService {

  constructor(
    private http: HttpClient,
    private globalService: GlobalService
    ) { }

  deleteCustomer(token, id){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.delete<any>(this.globalService.deleteCustomer(id), httpOptions)
  }

  deleteProfile(token, user_id){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.delete<any>(this.globalService.deleteProfile(user_id), httpOptions)
  }

  deleteContract(token, contractId): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.delete<any>(this.globalService.getDeleteContractURL(contractId), httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  deleteGroup(token, groupId, id): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.getDeleteGroupURL(groupId), id, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  delFolder(token, id){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.delete<any>(this.globalService.deleteFolder(id), httpOptions)
  }  
}
